"use strict";
// 国家码映射关系表
// http://wuji.oa.com/p/edit?appid=video_international_conf_online&schemaid=t_i18n_country_code_map&pagesize=1000&currentpage=1
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCountryAreacodeByCode = exports.findCountryCodeByName = exports.findCountryNameByCode = exports.COUNTRIES = void 0;
var constants_1 = require("../utils/constants");
exports.COUNTRIES = [
    {
        country_utc: '+08:00',
        country_code: 153514,
        country_name: '台湾省',
        country_areacode: '+886',
        country_abbr: 'tw',
    },
    {
        country_areacode: '+1',
        country_code: 153560,
        country_name: '美国',
        country_utc: '-04:00',
        country_abbr: 'us',
    },
    {
        country_name: '中国',
        country_areacode: '+86',
        country_code: 153505,
        country_utc: '+08:00',
        country_abbr: 'cn',
    },
    {
        country_areacode: '+66',
        country_name: '泰国',
        country_utc: '+07:00',
        country_code: 153548,
        country_abbr: 'th',
    },
    {
        country_code: 153496,
        country_name: '不丹',
        country_utc: '+06:00',
        country_areacode: '',
        country_abbr: 'bt',
    },
    {
        country_code: 153497,
        country_name: '丹麦',
        country_areacode: '+45',
        country_utc: '+02:00',
        country_abbr: 'dk',
    },
    {
        country_utc: '-03:00',
        country_code: 153498,
        country_name: '乌拉圭',
        country_areacode: '',
        country_abbr: 'uy',
    },
    {
        country_name: '以色列',
        country_areacode: '',
        country_code: 153499,
        country_utc: '+03:00',
        country_abbr: 'il',
    },
    {
        country_code: 153500,
        country_name: '伊朗',
        country_areacode: '+98',
        country_utc: '+04:30',
        country_abbr: 'ir',
    },
    {
        country_name: '俄罗斯',
        country_areacode: '+7',
        country_code: 153501,
        country_utc: '+03:00',
        country_abbr: 'ru',
    },
    {
        country_code: 153502,
        country_name: '保加利亚',
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'bg',
    },
    {
        country_areacode: '',
        country_utc: '+02:00',
        country_code: 153503,
        country_name: '克罗地亚',
        country_abbr: 'hr',
    },
    {
        country_areacode: '',
        country_utc: '+00:00',
        country_name: '冰岛',
        country_code: 153506,
        country_abbr: 'is',
    },
    {
        country_code: 153507,
        country_name: '加拿大',
        country_areacode: '+1',
        country_utc: '-04:00',
        country_abbr: 'ca',
    },
    {
        country_utc: '+02:00',
        country_code: 153508,
        country_name: '匈牙利',
        country_areacode: '+36',
        country_abbr: 'hu',
    },
    {
        country_utc: '+02:00',
        country_code: 153510,
        country_areacode: '+27',
        country_name: '南非',
        country_abbr: 'za',
    },
    {
        country_utc: '+02:00',
        country_code: 153511,
        country_name: '卢森堡',
        country_areacode: '',
        country_abbr: 'lu',
    },
    {
        country_code: 153512,
        country_name: '印度',
        country_areacode: '+91',
        country_utc: '+05:30',
        country_abbr: 'in',
    },
    {
        country_areacode: '+62',
        country_code: 153513,
        country_name: '印度尼西亚',
        country_utc: '+07:00',
        country_abbr: 'id',
    },
    {
        country_name: '吉尔吉斯斯坦',
        country_areacode: '',
        country_utc: '+06:00',
        country_code: 153515,
        country_abbr: 'kg',
    },
    {
        country_code: 153516,
        country_name: '哈萨克斯坦',
        country_areacode: '+7',
        country_utc: '+06:00',
        country_abbr: 'kz',
    },
    {
        country_code: 153517,
        country_name: '哥伦比亚',
        country_utc: '-05:00',
        country_areacode: '+57',
        country_abbr: 'co',
    },
    {
        country_code: 153518,
        country_name: '哥斯达黎加',
        country_utc: '-06:00',
        country_areacode: '',
        country_abbr: 'cr',
    },
    {
        country_areacode: '+90',
        country_code: 153519,
        country_name: '土耳其',
        country_utc: '+03:00',
        country_abbr: 'tr',
    },
    {
        country_code: 153520,
        country_name: '坦桑尼亚',
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'tz',
    },
    {
        country_code: 153521,
        country_name: '埃及',
        country_utc: '+02:00',
        country_areacode: '+20',
        country_abbr: 'eg',
    },
    {
        country_name: '塞尔维亚',
        country_areacode: '',
        country_utc: '+02:00',
        country_code: 153522,
        country_abbr: 'rs',
    },
    {
        country_name: '墨西哥',
        country_areacode: '+52',
        country_code: 153523,
        country_utc: '-05:00',
        country_abbr: 'yt',
    },
    {
        country_name: '奥地利',
        country_areacode: '+43',
        country_code: 153524,
        country_utc: '+02:00',
        country_abbr: 'at',
    },
    {
        country_code: 153525,
        country_name: '委内瑞拉',
        country_areacode: '+58',
        country_utc: '-04:00',
        country_abbr: 've',
    },
    {
        country_code: 153526,
        country_name: '巴拿马',
        country_areacode: '',
        country_utc: '-05:00',
        country_abbr: 'pa',
    },
    {
        country_utc: '-02:00',
        country_code: 153527,
        country_name: '巴西',
        country_areacode: '+55',
        country_abbr: 'br',
    },
    {
        country_code: 153528,
        country_name: '希腊',
        country_areacode: '+30',
        country_utc: '+03:00',
        country_abbr: 'gr',
    },
    {
        country_areacode: '+49',
        country_code: 153529,
        country_name: '德国',
        country_utc: '+02:00',
        country_abbr: 'de',
    },
    {
        country_name: '意大利',
        country_utc: '+02:00',
        country_code: 153530,
        country_areacode: '+39',
        country_abbr: 'it',
    },
    {
        country_code: 153531,
        country_name: '拉脱维亚',
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'lv',
    },
    {
        country_code: 153532,
        country_name: '挪威',
        country_utc: '+01:00',
        country_areacode: '+47',
        country_abbr: 'no',
    },
    {
        country_code: 153533,
        country_name: '捷克',
        country_areacode: '',
        country_utc: '+02:00',
        country_abbr: 'cz',
    },
    {
        country_areacode: '',
        country_utc: '+02:00',
        country_name: '斯洛伐克',
        country_code: 153534,
        country_abbr: 'sk',
    },
    {
        country_code: 153535,
        country_name: '斯洛文尼亚',
        country_areacode: '',
        country_utc: '+02:00',
        country_abbr: 'si',
    },
    {
        country_code: 153536,
        country_utc: '+08:00',
        country_name: '新加坡',
        country_areacode: '',
        country_abbr: 'sg',
    },
    {
        country_name: '新西兰',
        country_areacode: '+64',
        country_utc: '+13:00',
        country_code: 153537,
        country_abbr: 'nz',
    },
    {
        country_code: 153538,
        country_name: '日本',
        country_areacode: '+81',
        country_utc: '+09:00',
        country_abbr: 'jp',
    },
    {
        country_code: 153539,
        country_name: '智利',
        country_areacode: '+56',
        country_utc: '-03:00',
        country_abbr: 'cl',
    },
    {
        country_name: '朝鲜',
        country_areacode: '',
        country_code: 153540,
        country_utc: '+09:00',
        country_abbr: 'kp',
    },
    {
        country_code: 153541,
        country_name: '格鲁吉亚',
        country_areacode: '',
        country_utc: '+04:00',
        country_abbr: 'ge',
    },
    {
        country_code: 153543,
        country_name: '比利时',
        country_areacode: '+32',
        country_utc: '+02:00',
        country_abbr: 'be',
    },
    {
        country_areacode: '',
        country_code: 153544,
        country_name: '沙特阿拉伯',
        country_utc: '+03:00',
        country_abbr: 'sa',
    },
    {
        country_areacode: '+33',
        country_utc: '+02:00',
        country_code: 153545,
        country_name: '法国',
        country_abbr: 'fr',
    },
    {
        country_code: 153546,
        country_name: '波兰',
        country_areacode: '+48',
        country_utc: '+02:00',
        country_abbr: 'pl',
    },
    {
        country_areacode: '',
        country_utc: '-05:00',
        country_code: 153547,
        country_name: '波多黎各',
        country_abbr: 'pr',
    },
    {
        country_areacode: '+61',
        country_utc: '+11:00',
        country_code: 153549,
        country_name: '澳大利亚',
        country_abbr: 'au',
    },
    {
        country_code: 153550,
        country_name: '澳门',
        country_areacode: '',
        country_utc: '+08:00',
        country_abbr: 'mo',
    },
    {
        country_areacode: '',
        country_code: 153551,
        country_name: '爱尔兰',
        country_utc: '+01:00',
        country_abbr: 'ie',
    },
    {
        country_name: '爱沙尼亚',
        country_utc: '+03:00',
        country_code: 153552,
        country_areacode: '',
        country_abbr: 'ee',
    },
    {
        country_code: 153553,
        country_name: '瑞典',
        country_utc: '+02:00',
        country_areacode: '+46',
        country_abbr: 'se',
    },
    {
        country_code: 153554,
        country_name: '瑞士',
        country_areacode: '+41',
        country_utc: '+02:00',
        country_abbr: 'ch',
    },
    {
        country_utc: '+03:00',
        country_name: '白俄罗斯',
        country_areacode: '',
        country_code: 153555,
        country_abbr: 'by',
    },
    {
        country_name: '秘鲁',
        country_utc: '-05:00',
        country_code: 153556,
        country_areacode: '+51',
        country_abbr: 'pe',
    },
    {
        country_code: 153557,
        country_utc: '+03:00',
        country_name: '立陶宛',
        country_areacode: '',
        country_abbr: 'lt',
    },
    {
        country_utc: '+03:00',
        country_code: 153558,
        country_name: '约旦',
        country_areacode: '',
        country_abbr: 'jo',
    },
    {
        country_utc: '+03:00',
        country_name: '罗马尼亚',
        country_areacode: '+40',
        country_code: 153559,
        country_abbr: 'ro',
    },
    {
        country_areacode: '+856',
        country_code: 153561,
        country_name: '老挝',
        country_utc: '+07:00',
        country_abbr: 'la',
    },
    {
        country_code: 153562,
        country_name: '芬兰',
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'fi',
    },
    {
        country_name: '英国',
        country_code: 153564,
        country_areacode: '+44',
        country_utc: '+00:00',
        country_abbr: 'gb',
    },
    {
        country_utc: '+02:00',
        country_areacode: '+31',
        country_code: 153565,
        country_name: '荷兰',
        country_abbr: 'nl',
    },
    {
        country_name: '菲律宾',
        country_areacode: '+63',
        country_utc: '+08:00',
        country_code: 153566,
        country_abbr: 'ph',
    },
    {
        country_code: 153567,
        country_areacode: '',
        country_name: '葡萄牙',
        country_utc: '+01:00',
        country_abbr: 'pt',
    },
    {
        country_code: 153568,
        country_areacode: '+34',
        country_utc: '+01:00',
        country_name: '西班牙',
        country_abbr: 'es',
    },
    {
        country_code: 153569,
        country_name: '越南',
        country_areacode: '+84',
        country_utc: '+07:00',
        country_abbr: 'vn',
    },
    {
        country_code: 153570,
        country_name: '阿富汗',
        country_areacode: '+93',
        country_utc: '+04:30',
        country_abbr: 'af',
    },
    {
        country_name: '阿尔巴尼亚',
        country_areacode: '',
        country_code: 153571,
        country_utc: '+02:00',
        country_abbr: 'al',
    },
    {
        country_code: 153572,
        country_name: '阿根廷',
        country_areacode: '+54',
        country_utc: '-03:00',
        country_abbr: 'ar',
    },
    {
        country_code: 153573,
        country_areacode: '',
        country_utc: '+04:00',
        country_name: '阿联酋',
        country_abbr: 'ae',
    },
    {
        country_utc: '+09:00',
        country_code: 153574,
        country_name: '韩国',
        country_areacode: '+82',
        country_abbr: 'kr',
    },
    {
        country_code: 153575,
        country_utc: '+08:00',
        country_name: '香港',
        country_areacode: '+852',
        country_abbr: 'hk',
    },
    {
        country_name: '马来西亚',
        country_areacode: '+60',
        country_utc: '+08:00',
        country_code: 153576,
        country_abbr: 'my',
    },
    {
        country_utc: '+02:00',
        country_code: 153577,
        country_areacode: '',
        country_name: '马耳他',
        country_abbr: 'mt',
    },
    {
        country_code: 153578,
        country_name: '黎巴嫩',
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'lb',
    },
    {
        country_name: '卡塔尔',
        country_code: 155514,
        country_areacode: '',
        country_utc: '+03:00',
        country_abbr: 'qa',
    },
    {
        country_areacode: '+216',
        country_utc: '+01:00',
        country_code: 155515,
        country_name: '突尼斯',
        country_abbr: 'tn',
    },
    {
        country_code: 156534,
        country_name: '摩洛哥',
        country_areacode: '+212',
        country_utc: '+01:00',
        country_abbr: 'ma',
    },
    {
        country_name: '缅甸',
        country_code: 157135,
        country_areacode: '+95',
        country_utc: '+06:30',
        country_abbr: 'mm',
    },
    {
        country_name: '斯洛伐克',
        country_code: 160088,
        country_areacode: '',
        country_utc: '+02:00',
        country_abbr: 'sk',
    },
    {
        country_code: 162304,
        country_areacode: '',
        country_utc: '+06:00',
        country_name: '巴勒斯坦',
        country_abbr: 'ps',
    },
    {
        country_utc: '+03:00',
        country_code: 305432,
        country_name: '伊拉克',
        country_areacode: '',
        country_abbr: 'iq',
    },
    {
        country_areacode: '',
        country_utc: '+03:00',
        country_code: 1321452,
        country_name: '埃塞俄比亚',
        country_abbr: 'et',
    },
    {
        country_name: '巴哈马',
        country_areacode: '',
        country_utc: '-05:00',
        country_code: 1323453,
        country_abbr: 'bs',
    },
    {
        country_code: 1333502,
        country_areacode: '',
        country_utc: '+03:00',
        country_name: '乌克兰',
        country_abbr: 'ua',
    },
    {
        country_areacode: '+213',
        country_code: 1336859,
        country_name: '阿尔及利亚',
        country_utc: '+01:00',
        country_abbr: 'dz',
    },
    {
        country_name: '尼日利亚',
        country_code: 1337288,
        country_areacode: '',
        country_utc: '+01:00',
        country_abbr: 'ng',
    },
    {
        country_code: 1608696,
        country_name: '蒙古',
        country_areacode: '',
        country_utc: '+08:00',
        country_abbr: 'mn',
    },
    {
        country_areacode: '+92',
        country_code: 1665820,
        country_name: '巴基斯坦',
        country_utc: '+05:00',
        country_abbr: 'pk',
    },
    {
        country_name: '柬埔寨',
        country_utc: '+07:00',
        country_code: 8236373,
        country_areacode: '+855',
        country_abbr: 'kh',
    },
    {
        country_code: 8236370,
        country_areacode: '',
        country_utc: '+03:00',
        country_name: '巴勒斯坦国',
        country_abbr: 'ps',
    },
    {
        country_code: 8236371,
        country_name: '刚果',
        country_utc: '+01:00',
        country_areacode: '',
        country_abbr: 'cg',
    },
    {
        country_utc: '-05:00',
        country_areacode: '+53',
        country_code: 8236372,
        country_name: '古巴',
        country_abbr: 'cu',
    },
    {
        country_code: 8236374,
        country_utc: '+03:00',
        country_name: '肯尼亚',
        country_areacode: '+254',
        country_abbr: 'ke',
    },
    {
        country_name: '卢旺达',
        country_areacode: '',
        country_utc: '+02:00',
        country_code: 8236375,
        country_abbr: 'rw',
    },
    {
        country_code: 8236376,
        country_areacode: '',
        country_name: '蒙古国',
        country_utc: '+08:00',
        country_abbr: 'mn',
    },
    {
        country_name: '孟加拉',
        country_code: 8236377,
        country_areacode: '',
        country_utc: '+06:00',
        country_abbr: 'bd',
    },
    {
        country_utc: '-03:00',
        country_code: 8236378,
        country_name: '苏里南',
        country_areacode: '',
        country_abbr: 'sr',
    },
    {
        country_code: 8236379,
        country_areacode: '',
        country_name: '土库曼斯坦',
        country_utc: '+05:00',
        country_abbr: 'tm',
    },
    {
        country_code: 8236380,
        country_name: '乌兹别克斯坦',
        country_areacode: '',
        country_utc: '+05:00',
        country_abbr: 'uz',
    },
    {
        country_code: 8236381,
        country_areacode: '',
        country_utc: '+03:00',
        country_name: '叙利亚',
        country_abbr: 'sy',
    },
    {
        country_name: '也门',
        country_areacode: '+967',
        country_code: 8236382,
        country_utc: '+03:00',
        country_abbr: 'ye',
    },
    {
        country_code: 8266785,
        country_name: '格陵兰',
        country_areacode: '+299',
        country_utc: '',
        country_abbr: 'gl',
    },
];
var findCountryNameByCode = function (code) {
    var name = constants_1.DEFAULT_COUNTRY.name;
    exports.COUNTRIES.forEach(function (item) {
        if (item.country_code === code) {
            name = item.country_abbr;
        }
    });
    return name;
};
exports.findCountryNameByCode = findCountryNameByCode;
var findCountryCodeByName = function (name) {
    var code = constants_1.DEFAULT_COUNTRY.code;
    exports.COUNTRIES.forEach(function (item) {
        if (item.country_abbr === name) {
            code = item.country_code;
        }
    });
    return code;
};
exports.findCountryCodeByName = findCountryCodeByName;
var findCountryAreacodeByCode = function (code) {
    var areacode = '';
    exports.COUNTRIES.forEach(function (item) {
        if (item.country_code === code) {
            areacode = item.country_areacode;
        }
    });
    return areacode;
};
exports.findCountryAreacodeByCode = findCountryAreacodeByCode;
